// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete-dropdown {
    position: absolute;
    z-index: 1000;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    margin-top: 0;
    padding-left: 0;
    list-style: none;
}

.autocomplete-dropdown li {
    padding: 6px 12px;
    cursor: pointer;
}

.autocomplete-dropdown li:hover,
.autocomplete-dropdown li:focus {
    background-color: #f1f1f1;
}

.upload-icon {
    background: #5e3ace;
    width: 35px;
    height: 35px;
    border-radius: 6px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.uploadGroupImg {
    filter: invert(1);
}

.uploaded-file {
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 10px;
}
.uploaded-file .close-img {
    top: -10px;
    right: -10px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/ai-agents/create-transcription/create-transcription.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".autocomplete-dropdown {\n    position: absolute;\n    z-index: 1000;\n    width: 100%;\n    max-height: 150px;\n    overflow-y: auto;\n    background: white;\n    border: 1px solid #ccc;\n    border-radius: 0 0 4px 4px;\n    margin-top: 0;\n    padding-left: 0;\n    list-style: none;\n}\n\n.autocomplete-dropdown li {\n    padding: 6px 12px;\n    cursor: pointer;\n}\n\n.autocomplete-dropdown li:hover,\n.autocomplete-dropdown li:focus {\n    background-color: #f1f1f1;\n}\n\n.upload-icon {\n    background: #5e3ace;\n    width: 35px;\n    height: 35px;\n    border-radius: 6px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.uploadGroupImg {\n    filter: invert(1);\n}\n\n.uploaded-file {\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    padding: 10px;\n}\n.uploaded-file .close-img {\n    top: -10px;\n    right: -10px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
